import { api } from '../lib/api-client.js';
import { useAuthStore } from '../stores/auth-store.js';

export async function vendorRequestLink(email: string): Promise<void> {
  await api('/vendor/auth/request-link', {
    method: 'POST',
    body: { email },
    skipRefresh: true,
  });
}

export async function vendorConsumeLink(token: string): Promise<void> {
  const response = await api<{
    accessToken: string;
    accessTokenExpiresAt: string;
    user: { id: string; name: string; email: string };
    vendorCompany: { id: string; name: string };
  }>('/vendor/auth/callback', {
    method: 'POST',
    body: { token },
    skipRefresh: true,
  });
  useAuthStore.getState().setTokens({
    accessToken: response.accessToken,
    refreshToken: '',
    kind: 'vendor',
  });
}

export async function vendorLogout(): Promise<void> {
  try {
    await api('/vendor/auth/logout', { method: 'POST', skipRefresh: true });
  } finally {
    useAuthStore.getState().clear();
  }
}

export async function fetchVendorMe() {
  return api<{ user: { name: string; email: string }; company: { name: string } }>('/vendor/me');
}
